import * as React from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";

import MenuMain from "./Menu/Main";
import styles from "./AppNav.module.css";
import iconUser from "./icon_user.svg";
import UIDropdown from "components/UI/Dropdown";

const Version = styled.div.attrs({ className: "v" })`
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  text-align: center;
  color: white;
`;

const OfficeDropdownContainer = styled.div.attrs({ className: "office-dd" })`
  padding: 16px 12px;
  background: ${props => props.theme.colors.shark};

  .dropdown,
  .dropdown input {
    background: ${props => props.theme.colors.mako};
    color: ${props => props.theme.colors.iron};
  }
  .chevron {
    filter: grayscale(1);
  }
`;

const officeToDropdownOption = office => ({
  value: office.id,
  text: office.name
});
const dropdownOptionToOffice = option => ({
  id: option.value,
  name: option.text
});

export class AppNav extends React.Component {
  componentDidMount() {
    this.props.fetchUserInfo();
  }

  render() {
    const { userOffice } = this.props;
    userOffice.options = userOffice.options.filter(office => office.id !== "");

    const client = this.props.user.ghostingCompany === "" ? this.props.user.client :  `${this.props.user.client} (${this.props.user.ghostingCompany})`;

    return (
      <nav className={styles.container} data-nav-menu>
        <header className={styles.heading}>
          <div className={`user-info ${styles.header}`}>
            <div style={{ display: "flex" }}>
              <img className={styles.icon} src={iconUser} alt="User Icon" />
              <span data-testid="username" className={styles.title}>
                {this.props.user.name}
              </span>
            </div>
            <div
              data-testid="companyname"
              className={styles.client}
              title={this.props.user.client}
            >
              {client}
            </div>
          </div>
        </header>

        {userOffice.current ? (
          <OfficeDropdownContainer>
            <UIDropdown
              className="dropdown"
              initialSelectedItem={officeToDropdownOption(userOffice.current)}
              value={userOffice.current.id}
              options={userOffice.options.map(officeToDropdownOption)}
              onChange={newValue =>
                this.props.setUserOffice(dropdownOptionToOffice(newValue))
              }
            />
          </OfficeDropdownContainer>
        ) : null}

        <MenuMain />

        <Version>{process.env.REACT_APP_VERSION}</Version>
      </nav>
    );
  }
}

AppNav.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string.isRequired,
    client: PropTypes.string
  }).isRequired,
  fetchUserInfo: PropTypes.func,
  userOffice: PropTypes.shape({
    current: PropTypes.object,
    options: PropTypes.array
  }).isRequired,
  setUserOffice: PropTypes.func.isRequired
};

AppNav.defaultProps = {
  fetchUserInfo: () => {}
};

export default AppNav;
